<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/affiliate/globalSettingAffiliate")
          i.fa.fa-cog
          span.ml-1 {{ $t("ui.global_setting_affiliate") }}
  div.row
    div.col-md-12
      div.card
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 40%;")
                  thead
                    tr
                      th.sticky-position(width="39%")
                        span {{ $tc('ui.key', 1) }}
                      th.sticky-position(width="39%")
                        span {{ $tc('ui.value', 1) }}
                      th.text-center.sticky-position(width="18%" v-if="showActionButton('updateglobalsettingaff')")
                        span {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="settingList.length == 0")
                      td(:colspan="showActionButton('updateglobalsettingaff') ? '3' : '2'").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in settingList")
                      td
                        span(:title='$t("ui." + item.setting_key)') {{ $t("ui." + item.setting_key) }}
                      td
                        span(:title="$helpers.isNumeric(item.setting_value) == true ? $n(item.setting_value, 'integer') : item.setting_value") {{ $helpers.isNumeric(item.setting_value) == true ? $n(item.setting_value, 'integer') : item.setting_value }}
                      td.actions(v-if="showActionButton('updateglobalsettingaff')")
                        span
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onUpdate(item)" :title="$t('ui.update')")
    updateglobalsettingaffiliate(ref="updateglobalsettingaffiliate" :item="editSelectedSetting" @clicked="afterUpdate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import updateglobalsettingaffiliate from "@/components/affiliate/updateGlobalSettingAffiliate.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    updateglobalsettingaffiliate
  },
  data: () => ({
    loading: false,
    feedback: {
      success: true,
      status: ""
    },
    settingList: [],
    editSelectedSetting: null,
  }),
  computed: {
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    this.getGlobalSettingList();
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    onUpdate(e) {
      this.editSelectedSetting = e;
      this.$refs.updateglobalsettingaffiliate.$refs.updateGlobalSettingAffiliate.show();
    },
    afterUpdate: function() {
      this.getGlobalSettingList();
      this.$helpers.showDialog(this.$t("ui.combine.update_global_setting_affiliate"), this.$t("message.success"), "success");
    },
    getGlobalSettingList: function(item) {
      let url = config.globalSettingListAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>